import { render, staticRenderFns } from "./fee-suject.vue?vue&type=template&id=8f8a2c94&scoped=true&"
import script from "./fee-suject.vue?vue&type=script&lang=js&"
export * from "./fee-suject.vue?vue&type=script&lang=js&"
import style0 from "./fee-suject.vue?vue&type=style&index=0&id=8f8a2c94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8a2c94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f8a2c94')) {
      api.createRecord('8f8a2c94', component.options)
    } else {
      api.reload('8f8a2c94', component.options)
    }
    module.hot.accept("./fee-suject.vue?vue&type=template&id=8f8a2c94&scoped=true&", function () {
      api.rerender('8f8a2c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/cost_warning_ratio_configuration/form/components/fee-suject.vue"
export default component.exports